import React from 'react'
import amazon from "../logos/amazon.jpg";
import { Link } from 'react-router-dom';
const BusinessAccount = () => {
  return (
    <div className="signup-page">
      <img src={amazon} alt="" className="amazon-logo" />
      <div className="signup-form">
        <form>

        <h2>Create Business Account</h2>
        <label htmlFor="name">Owner name</label>
        <input
          type="text"
          className="input-field"
          id="name"
          placeholder="first name and last name"
          required
        />
         <label htmlFor="shop-name">Shop name</label>
        <input
          type="text"
          className="input-field"
          id="shop-name"
          required
        />
        <label htmlFor="email">Mobile number or email</label>
        <input type="email" id="email" required className="input-field" />
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          className="input-field"
          required
          placeholder="At least 6 characters"
        />
        <label htmlFor="password">Re-enter Password</label>
        <input type="password" id="password" className="input-field" required />
        <label htmlFor="shop-type">Shop Type</label>
        <input type="text" list='shop-type' className='input-field' required/>
        <datalist typeof='list' id='shop-type'>
            <option value="Grocery"/>
            <option value="Garments"/>
            <option value="Sports"/>
            <option value="Shoes"/>
            <option value="Mobile"/>
            <option value="Laptop"/>
            <option value="Vehicle"/>
            <option value="Books"/>
            <option value="Glasses"/>
            <option value="TV"/>
            <option value="Cupboards"/>
            <option value="Furniture"/>
            <option value="Wiring"/>
            <option value="Bags"/>
        </datalist>
        <h2>Location</h2>
        <label htmlFor="country">Country</label>
        <input type="text" className="input-field" id="country" required/>
        <label htmlFor="city">City</label>
        <input type="text" className="input-field" id="city" required/>
        <label htmlFor="street">Street Address</label>
        <input type="text" className="input-field" id="street" required/>
        <label htmlFor="postal">Postal Code</label>
        <input type="text" className="input-field" id="postal" required/>
        <button className="btn btn-continue">Continue</button>
        <div>
          <p className="form-text">
            By creating an account, you agree to Amazon's
            <Link className="link" to="/about"> Conditions of Use</Link> and
            <Link className="link" to="/about"> Privacy Notice</Link>.
          </p>
        </div>
        <p className="form-text">
          Already have an Account <Link className="link" to="/login"> Sign in</Link>
        </p>
        </form>
      </div>
    </div>
  )
}

export default BusinessAccount
